import { createTypedReducerWithImmer } from "@insite/client-framework/Common/CreateTypedReducer";
import ApplicationState from "@insite/client-framework/Store/ApplicationState";
import { AnyAction, reducers } from "@insite/client-framework/Store/Reducers";
import CustomShipViaAccountNumberState from "@theHescoBlueprint/Handlers/CustomShipViaAccountNumberState";
import { Draft } from "immer";

const initialState: CustomShipViaAccountNumberState = {
    isPlacingOrder: false,
    isApplyingPromotion: false,
    isCheckingOutWithPayPay: false,
    accountNumber: "",
    isCustomUnhandledPopUpOpen: false,
    isPreloadingData: false,
    poNumber: "",
    fileUploadData: "",
    shipOrderComplete: false,
};
const customState = createTypedReducerWithImmer(initialState, {
    "Custom/CheckoutReview/SetFileUploadData": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { fileUploadData: any },
    ) => {
        draft.fileUploadData = action.fileUploadData;
    },
    "Custom/CheckoutReview/SetShipOrderComplete": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { ship: boolean },
    ) => {
        draft.shipOrderComplete = action.ship;
    },
    "Custom/CheckoutReview/SetAccountNumber": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { accountNumber: string },
    ) => {
        draft.accountNumber = action.accountNumber;
    },
    "Custom/Data/FailedCustomPopUp": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { openModal: boolean },
    ) => {
        draft.isCustomUnhandledPopUpOpen = action.openModal;
    },
    "Custom/Data/SetCloseUnhandledModel": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { closeModel: boolean },
    ) => {
        draft.isCustomUnhandledPopUpOpen = !action.closeModel;
    },
    "Custom/CheckoutReview/SetPoNumber": (
        draft: Draft<CustomShipViaAccountNumberState>,
        action: { poNumber: string },
    ) => {
        draft.poNumber = action.poNumber;
    },
});
(reducers as any).customState = customState;

export type CustomState = {
    customState: CustomShipViaAccountNumberState;
} & ApplicationState;

type Reducers = {
    customState: typeof customState;
};

export type CustomActions = Parameters<Reducers[keyof Reducers]>[1] | AnyAction;
